import React from "react";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";

interface Props {
  value: boolean;
  onChange: (value: boolean) => void;
}

export const YesNoRadioGroupForInPageEditing = (props: Props) => {
  const [value, setValue] = React.useState(props.value ? "true" : "false");

  const onChange = (v: string) => {
    const boolValue = v === "true";
    if (boolValue !== props.value) {
      setValue(v);
      props.onChange(boolValue);
    }
  }

  return <div style={{ paddingTop: 6, paddingLeft: 8 }}>
    <RadioGroup
      orientation="horizontal"
      options={[
        { label: RESX.GeneralLabels.lblYes, value: "true" },
        { label: RESX.GeneralLabels.lblNo, value: "false" }
      ]}
      value={value}
      onChange={onChange}
    />
  </div>
}

interface YesNoTextProps {
  value: boolean;
  yesLabel?: React.ReactNode;
  noLabel?: React.ReactNode;
}
export const YesNoText = (props: YesNoTextProps) => {
  return <div>{
    props.value
      ? (props.yesLabel ?? RESX.GeneralLabels.lblYes)
      : (props.noLabel || RESX.GeneralLabels.lblNo)
  }</div>;
}